// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container-max-width-xs[data-v-372bf818]{max-width:0}.container-max-width-sm[data-v-372bf818]{max-width:576px}.container-max-width-md[data-v-372bf818]{max-width:768px}.container-max-width-lg[data-v-372bf818]{max-width:992px}.container-max-width-xl[data-v-372bf818]{max-width:1200px}.container-max-width-xxl[data-v-372bf818]{max-width:1900px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
